import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import * as _ from "lodash";
import StatisticsCircles from "../certificates/StatisticsCircles";
import CertificateHeader from "../certificates/CertificateHeader";
import ScoreDistributionTile from "../dashboard/ScoreDistributionTile";
import CriteriaStatistics from "../certificates/CriteriaStatistics";
import ArturCommitment from "../certificates/ArturCommitment";
import Reviews from "../profile/Reviews";
import { useGetVendorId } from "../../hooks/global/User";
import { useTranslation } from "react-i18next";
import { getVendor } from "../../fetchers/vendor";
import {
  getDetailedRatings,
  getVendorStats,
  getScoreStats,
  getWithTextStats,
} from "../../fetchers/stats";
import { getModuleIdFromProduct, getProductGroups, getProductsId } from "../../fetchers/products";
import { isValidUUID } from "../../helpers/general";
import { useSelectLanguage } from "../../hooks/global/Languages";

function Certificate() {
  const vendorId = useGetVendorId();
  const { t, i18n } = useTranslation();
  const lng = i18n.language;
  const [vendor, setVendor] = useState();
  const [reviews, setReviews] = useState("");
  const [reviewsStatistics, setReviewsStatistics] = useState("");
  const [averageScore, setAverageScore] = useState(0);
  const [countReviews, setCountReviews] = useState(0);
  const [group, setGroup] = useState("");
  const [product, setProduct] = useState("");
  const [urlParams] = useSearchParams();
  const [elementId, setElementId] = useState();
  const [moduleId, setModuleId] = useState();

  const [createdAfterDate, setCreatedAfterDate] = useState(1);
  const [createdBeforeDate, setCreatedBeforeDate] = useState(9999999999999);
  const [reviewStatus, setReviewStatus] = useState("APPROVED");
  const [vendorScores, setVendorScores] = useState();
  const [reviewsQuery, setReviewsQuery] = useState(undefined);
  const [withTextSize, setWithTextSize] = useState(0);
  const [selectedModule, setSelectedModule] = useState();

  const { selectTextByLanguage } = useSelectLanguage()


  useEffect(() => {
    let eId = urlParams.get("elementId");
    if(!eId) setElementId(eId);
    if (eId && !isValidUUID(eId)) {
      getProductsId({ eId, vendorId }).then((product) => {
        setElementId(product.id);
      });
    } else {
      setElementId(eId);
    }
  }, []);


  useEffect(() => {
    
    let mId = urlParams.get("moduleId");
    if(!mId) setElementId(mId);
    if(!isValidUUID(mId)) {
      if (elementId && mId && mId === 'produkti') {
        getModuleIdFromProduct({ eId:elementId, vendorId }).then((m) => {
          setModuleId(m.id);
        });
      } else {
        setModuleId(mId);
    }
  } else {
    setModuleId(mId);
  }
  }, [elementId]);


  useEffect(() => {

    if (isValidUUID(moduleId) || moduleId == 'PROFILES' || moduleId == 'COMPANY' || moduleId == null) {

      let groupFunc = urlParams.get("moduleId");
      if (groupFunc === 'PROFILES') groupFunc = 'COMPANY';
      if(groupFunc === 'produkti') groupFunc = moduleId;
      let productFunc = urlParams.get("product") || elementId;

      (groupFunc == null) ? setGroup("ALL") : setGroup(groupFunc);
      (productFunc == null) ? setProduct("ALL") : setProduct(productFunc);

      getVendor(vendorId).then((vendors) => {
        setVendor(vendors);
      });

      let params = {
        vendorId: vendorId,
        group: groupFunc,
        product: productFunc,
        lang: lng.toLocaleUpperCase(),
        reviewStatus: reviewStatus
      };

      getProductGroups(params).then((vendorModules) => {
        if (params.group) {
          const sModule = vendorModules.find((q) => q.id === params.group);
          sModule ? setSelectedModule(sModule) : setSelectedModule(vendorModules[0]);
        }
      });
    }
  }, [moduleId]);


  useEffect(() => {
    getDetailedRatings(vendorId, group, product === 'ALL' ? '' : product, createdAfterDate, createdBeforeDate).then((detailedRatings) => {
      setReviewsStatistics(detailedRatings);
    });
  }, [selectedModule]);

  useEffect(() => {
    if (group) {
      getVendorStats(vendorId, group, product === 'ALL' ? '' : product, createdAfterDate, createdBeforeDate).then((vendorScores) => {
        setAverageScore(vendorScores.score);
        setCountReviews(vendorScores.count);
      });
      getScoreStats(vendorId, group, product, createdAfterDate, createdBeforeDate).then((vendorScores) => {
        setVendorScores(_.map(vendorScores, "count"));
      });
      getWithTextStats(vendorId, group, product, createdAfterDate, createdBeforeDate).then((reviewTextStats) => {
        setWithTextSize(reviewTextStats);
      });
    }
  }, [reviewsStatistics]);

  useEffect(() => {
    const temp = {
      vendorId: vendorId,
      group: !selectedModule ? 'ALL' : selectedModule?.id,
      productSourceIds: product || 'ALL',
      companyId: group === "COMPANY" && product !== 'ALL' ? product : '',
      lang: lng.toLocaleUpperCase(),
      createdAfterDate: createdAfterDate,
      createdBeforeDate: createdBeforeDate,
      reviewStatus: reviewStatus,
    }
    setReviewsQuery(temp);

  }, [reviewsStatistics]);

  return (
    <div id="artur-vendorCertificate">
      <div className="container-fluid cerificateHeaderContainer">
        <div className="row">
          <div className="container">
            <div className="row">
              <div className="col-md-12 certificateHeaderWrap">
                {vendor && <CertificateHeader name={vendor.name} />}
                <h3>{t("admin.cert.h1")}</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container cerificateContentContainer">
        <div className="row certificateBreadCrumbs">
          <div className="col-md-12">
            <p>
              {/*JSON.stringify(selectedModule.name || selectedModule.nametoshow)*/}
              {/*{selectTextByLanguage(selectedModule.nametoshow, lng)} {product} && <span> » {product}</span>*/}
            </p>
          </div>
        </div>

        <div className="row certificateStatistics">
          <div className="col-md-8">
            <StatisticsCircles
              averageScore={averageScore}
              countReviews={countReviews}
              npsCount={Math.round(averageScore * 100 / 5)}
            />
          </div>
          <div className="col-md-4">
            <div className="reviewsScoreDistributionWrap">
              {vendorScores && (
                <ScoreDistributionTile
                  showHeader={true}
                  showTitleTile={false}
                  rate1Count={_.parseInt(vendorScores[0])}
                  rate2Count={_.parseInt(vendorScores[1])}
                  rate3Count={_.parseInt(vendorScores[2])}
                  rate4Count={_.parseInt(vendorScores[3])}
                  rate5Count={_.parseInt(vendorScores[4])}
                />
              )}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-8 col-md-pull-4 certificateReviews">
            {vendorScores && reviewsQuery ? (
              <Reviews
                scores={vendorScores}
                withTextSize={withTextSize.count}
                searchReviewsQuery={reviewsQuery}
                editable={false}
                elementDetailsVisible={false}
                key={reviews.id}
                pageSize={20}
                countReviews={countReviews}
              />

            ) : (
              <div className="noRatings">{t("admin.common.noData")}</div>
            )}
          </div>
          <div className="col-md-4 col-md-push-8 certificateSidebar">

            {reviewsStatistics && (
              <CriteriaStatistics
                lng={lng}
                reviewsStatistics={reviewsStatistics}
              />
            )}
            <ArturCommitment />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Certificate;
